import { useState, useEffect } from "react";
import Promo1 from "../img/pLunesMartes/1.webp";
import Promo2 from "../img/pLunesMartes/2.webp";
import Promo3 from "../img/pLunesMartes/3.webp";
import Promo4 from "../img/pLunesMartes/4.webp";
import Promo5 from "../img/pLunesMartes/5.webp";
import Promo6 from "../img/pLunesMartes/6.webp";
import Promo7 from "../img/pLunesMartes/7.webp";
import Promo8 from "../img/pLunesMartes/8.webp";
import Promo9 from "../img/pLunesMartes/9.webp";
import Logo from "../img/Logotipo.webp";
import imgNav from "../img/fondo1.webp";
import { motion } from "framer-motion";
import { showSuccess } from "./Utils/toastUtils";

const promos = [
  { id: 1, img: Promo1, nombre: "Promo 1", precio: 4.00 },
  { id: 2, img: Promo2, nombre: "Promo 2", precio: 5.48 },
  { id: 3, img: Promo3, nombre: "Promo 3", precio: 3.50 },
  { id: 4, img: Promo4, nombre: "Promo 4", precio: 5.98 },
  { id: 5, img: Promo5, nombre: "Promo 5", precio: 1.00 },
  { id: 6, img: Promo6, nombre: "Promo 6", precio: 4.00 },
  { id: 7, img: Promo7, nombre: "Promo 7", precio: 4.00 },
  { id: 8, img: Promo8, nombre: "Promo 8", precio: 4.50 },
  { id: 9, img: Promo9, nombre: "Promo 9", precio: 6.90 },
];

const PLunesYmartes = ({ onAgregarPromo, onSiguiente }) => {
  const [loading, setLoading] = useState(true);
  const [imgsLoaded, setImgsLoaded] = useState(0);
  const [selectedPromoId, setSelectedPromoId] = useState(null);

  const totalImages = promos.length + 2;

  useEffect(() => {
    if (imgsLoaded >= totalImages) {
      setLoading(false);
    }
  }, [imgsLoaded, totalImages]);

  const handleClickPromo = (promo) => {
    setSelectedPromoId(prev => (prev === promo.id ? null : promo.id));
  };

  const handleAgregar = (promo) => {
    // Enriquecer la promo con el tipo antes de mandar a agregar
    const promoConTipo = { ...promo, tipoModulo: "lm" };
    if (onAgregarPromo) onAgregarPromo(promoConTipo);
    showSuccess(`${promo.nombre} agregado!`);
    setSelectedPromoId(null);
  };

  return (
    <div className="min-h-screen !bg-transparent p-8 sm:p-8 rounded-2xl w-full flex flex-col items-center px-3 py-3 -mt-12 relative overflow-hidden">
      <img 
        src={imgNav} 
        alt="Fondo" 
        className="absolute inset-0 w-full h-full object-cover -z-10 pointer-events-none" 
        onLoad={() => setImgsLoaded(prev => prev + 1)}
      />

      {loading && (
        <motion.div
          key="loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 flex flex-col items-center justify-center !bg-transparent rounded-2xl z-50 pointer-events-none"
        >
          <div className="w-16 h-16 border-4 border-neutral-200 border-t-transparent rounded-full animate-spin"></div>
        </motion.div>
      )}

      <div className={`${loading ? "pointer-events-none select-none opacity-0" : "opacity-100 transition-opacity duration-500"} w-full flex flex-col items-center !bg-transparent`}>
        <img
          src={Logo}
          alt="Logo"
          className="w-32 mx-auto"
          style={{ objectFit: "contain" }}
          onLoad={() => setImgsLoaded(prev => prev + 1)}
        />

        <h1 className="text-gray-500 text-3xl font-bold mb-4 text-center -mt-10">
          Lunes y Martes de{" "}
          <strong className="text-yellow-400">Bajo Presupuesto</strong>
        </h1>
        <h2 className="text-gray-500/50 text-sm font-bold mb-8 text-center">
          Para agregar, solo presiona.
        </h2>

        <div className="w-full max-w-md flex flex-wrap justify-between items-center bg-transparent">
          {promos.map((promo, index) => (
            <div
              key={promo.id}
              className="flex flex-col items-center cursor-pointer w-[45%] relative"
              style={{ marginTop: index >= 2 ? "-3rem" : "0" }}
              onClick={() => handleClickPromo(promo)}
            >
              <p className="text-yellow-500 text-[10px] sm:text-xs text-center font-extrabold leading-tight z-10 uppercase tracking-tighter">
                {promo.nombre}
              </p>

              <div className="relative w-full">
                <div className="relative -mt-[50px] flex items-center justify-center min-h-[120px]">
                  <img
                    src={promo.img}
                    alt={promo.nombre}
                    className={`w-full h-auto object-contain rounded-md transition-opacity duration-300 ${
                      selectedPromoId === promo.id ? "opacity-0 pointer-events-none" : "opacity-100"
                    }`}
                    onLoad={() => setImgsLoaded((prev) => prev + 1)}
                  />

                  {selectedPromoId === promo.id && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <button
                        className="bg-yellow-500 text-white font-bold py-2 px-6 rounded-full shadow-lg z-30"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAgregar(promo);
                        }}
                      >
                        Agregar
                      </button>
                    </div>
                  )}
                </div>
                
                <div className={`absolute top-0 right-0 bg-yellow-500 text-white text-xs sm:text-sm font-black px-2 py-0.5 rounded-full shadow-lg z-20 transition-opacity duration-300 ${
                  selectedPromoId === promo.id ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}>
                  ${promo.precio}
                </div>
              </div>
            </div>
          ))}

          <div className="w-[45%] flex justify-center items-center mt-[-3rem]">
            <button
              className="bg-yellow-500 text-white font-bold py-2 px-6 rounded-xl hover:bg-yellow-400 transition"
              onClick={onSiguiente}
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
      
      <style>{`
        .bg-white.rounded-2xl.w-\\[90\\%\\].max-w-sm.sm\\:max-w-md.lg\\:max-w-lg.max-h-\\[80vh\\] {
          background: transparent !important;
          box-shadow: none !important;
        }
      `}</style>
    </div>
  );
};

export default PLunesYmartes;
